/** Edition routing: map a pathname to the edition it targets. */

export type EditionId = "core" | "accenture";

export type EditionForPath = {
  edition: EditionId;
  /** The pathname with the edition prefix stripped. */
  rest: string;
};

const ACCENTURE_PREFIX = "/accenture-edition";

export function editionForPath(pathname: string): EditionForPath {
  if (pathname === ACCENTURE_PREFIX || pathname.startsWith(ACCENTURE_PREFIX + "/")) {
    const rest = pathname.slice(ACCENTURE_PREFIX.length) || "/";
    return { edition: "accenture", rest };
  }
  return { edition: "core", rest: pathname };
}

export function editionPrefix(edition: EditionId): string {
  return edition === "accenture" ? ACCENTURE_PREFIX : "";
}
